// Make sure external urls starts with http(s) or //,
// otherwise nextjs thinks its an internal url
const setExternalUrl = url => {
  if (/^((https?:)?\/\/)|mailto:/i.test(url)) return url;
  return `//${url}`;
};

export default setExternalUrl;
